import React,{Fragment,useEffect} from 'react';
import { RootState} from 'ReduxStore/store'
import { Redirect, Route,useHistory ,withRouter,Link,useParams} from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { GetAllExercises} from 'ReduxStore/exercises/Action'
import { useStyles } from 'Components/Reusable/Categories/categories.style';
import category from 'Assets/img/svg/categoriesImage.svg';
import Header from 'Components/Header/Header';
import { categories } from 'Utils/options';
import MenuCard from 'Components/Reusable/Menu/MenuCard';

interface RouteParams {
  id:string
}

const ListAllExercises =() => {
  const classes = useStyles();
    const dispatch = useDispatch()
    const allExercises:any[] = useSelector((state:RootState) => state.exercise)
    //eslint-disable-next-line 
    console.log(allExercises)
    const params = useParams<RouteParams>();
    //eslint-disable-next-line 
    console.log("Id is",params.id)
    const id:any = localStorage.getItem('currentChildId')
    //eslint-disable-next-line 
    console.log("Id is",id)
    useEffect(() => {

		// dispatch(GetAllExercises())
	  }, []);
    return(
        <Fragment>
            <div className="">
          <Header />

          {/* <img src={menuImage} alt="" className={classes.menuHeaderImage} /> */}
        </div>
        <ul className={classes.listItems}>
          {categories.map(content => (
            <li key={content.id} className="my-3">
              {
                <MenuCard
                  url={content.url}
                  image={content.backgroundImage}
                  type={content.type}
                  common={{ width: '100%', height: '80.74px' }}
                  description={content.description}
                  icon={content.icon}
                />
              }
            </li>
          ))}
        </ul>
        </Fragment>
    )
}

export default ListAllExercises;
